import { jsxs as k, jsx as _ } from "react/jsx-runtime";
import { useRef as A, useState as z, useMemo as W, useCallback as w, useEffect as D } from "react";
import { V as v } from "./index-PMSPXTub.js";
import { c as H } from "./clsx-OuTLNxxd.js";
import { B as V } from "./Button-BrO5Axzv.js";
import './TableScrollContainer.css';const x = 600, I = ({ cellWidth: C, maxRows: p }) => {
  const u = A(null), [a, c] = z(0), [T, B] = z(!1), [r, y] = z({
    pinCount: 0,
    rowCount: 0,
    headings: null
  }), [S, m] = z({
    top: !1,
    bottom: !1,
    left: !1,
    right: !1
  }), e = W(
    () => S.left || S.right,
    [S.left, S.right]
  ), i = w(() => {
    if (!u.current) return null;
    const t = u.current.querySelector("table"), o = u.current.getElementsByTagName("thead")[0], n = u.current.getElementsByTagName("tbody")[0], d = u.current.getElementsByTagName("tfoot")[0];
    if (!t || !o) return null;
    const s = o.getElementsByTagName("th");
    return s.length ? { container: u.current, table: t, headings: s, tbody: n, tfoot: d } : null;
  }, []), h = w(() => {
    var f;
    const t = i();
    if (!t) return;
    const { headings: o, tbody: n } = t, d = ((f = n == null ? void 0 : n.getElementsByTagName("tr")) == null ? void 0 : f.length) || 0, s = T ? 0 : [...o].filter((g) => g.dataset.pinned === "true").length;
    y({
      pinCount: s,
      rowCount: d,
      headings: o
    });
  }, [i, T]), E = w(() => {
    const t = i();
    if (!t) return { left: !1, right: !1 };
    const { container: o, table: n } = t, d = o.clientWidth, s = n.clientWidth, f = a >= 0, g = a <= -(s - d);
    return {
      left: !f,
      right: !g && s > d
    };
  }, [a, i]), N = w(() => {
    if (!r.headings)
      return { top: !1, bottom: !1 };
    const t = i();
    if (!t || !t.tbody || !t.tfoot)
      return { top: !1, bottom: !1 };
    const { tbody: o, tfoot: n } = t, d = r.headings[0].getBoundingClientRect().bottom, s = n.getBoundingClientRect().top, f = o.getBoundingClientRect().top, g = o.getBoundingClientRect().bottom;
    return {
      top: f < d,
      bottom: g > s
    };
  }, [i, r.headings]), b = w(
    (t = !1) => {
      const o = E();
      if (t) {
        const n = N();
        m({
          ...o,
          ...n
        });
      } else
        m((n) => ({
          ...n,
          ...o
        }));
    },
    [E, N]
  ), M = w(
    (t) => {
      const o = i();
      if (!o) return;
      const { container: n, table: d } = o, s = n.clientWidth, f = d.clientWidth, g = Math.max(0, f - s), F = t === "left" ? Math.min(0, a + C) : Math.max(-g, a - C);
      c(F), b();
    },
    [C, b, a, i]
  );
  return D(() => {
    B(window.innerWidth <= x), h();
    const t = !!p && !!r.rowCount && p < r.rowCount;
    b(t);
    const o = () => {
      B(window.innerWidth <= x), h(), b(!!p);
    };
    return window.addEventListener("resize", o), () => {
      window.removeEventListener("resize", o);
    };
  }, [p, b, h, r.rowCount]), {
    scrollRef: u,
    currentTransform: a,
    scrollDirection: S,
    shouldShowScrollButtons: e,
    pinCount: r.pinCount,
    onScrollClick: M,
    checkScroll: b,
    rowCount: r.rowCount
  };
}, L = "_wrapper_5ildb_32", j = "_captionWrapper_5ildb_41", O = "_caption_5ildb_41", $ = "_buttonWrapper_5ildb_58", q = "_button_5ildb_58", K = "_innerWrapper_5ildb_72", P = "_hasMaxHeight_5ildb_78", X = "_hasScrollShadowEnd_5ildb_82", G = "_hasScrollShadowStart_5ildb_91", J = "_hasScrollShadowTop_5ildb_100", Q = "_hasScrollShadowBottom_5ildb_109", R = "_hasVerticalScroll_5ildb_126", U = "_hasHorizontalScroll_5ildb_130", Y = "_scrollFullWidth_5ildb_134", l = {
  wrapper: L,
  captionWrapper: j,
  caption: O,
  buttonWrapper: $,
  button: q,
  innerWrapper: K,
  hasMaxHeight: P,
  hasScrollShadowEnd: X,
  hasScrollShadowStart: G,
  hasScrollShadowTop: J,
  hasScrollShadowBottom: Q,
  hasVerticalScroll: R,
  hasHorizontalScroll: U,
  scrollFullWidth: Y
}, lt = ({
  caption: C,
  cellWidth: p = 60,
  children: u,
  className: a,
  maxRows: c,
  ...T
}) => {
  const {
    checkScroll: B,
    currentTransform: r,
    onScrollClick: y,
    pinCount: S,
    rowCount: m,
    scrollDirection: e,
    scrollRef: i,
    shouldShowScrollButtons: h
  } = I({
    maxRows: c,
    cellWidth: p
  }), E = W(
    () => H(
      l.wrapper,
      {
        [l.hasScrollShadowTop]: e.top,
        [l.hasScrollShadowBottom]: e.bottom,
        [l.scrollFullWidth]: !e.left || !h,
        [l.hasVerticalScroll]: e.top || e.bottom,
        [l.hasHorizontalScroll]: e.left || e.right
      },
      a
    ),
    [a, e, h]
  ), N = W(
    () => H(l.innerWrapper, {
      [l.hasMaxHeight]: c,
      [l.hasScrollShadowEnd]: h && e.right,
      [l.hasScrollShadowStart]: h && e.left
    }),
    [c, h, e.right, e.left]
  ), b = W(
    () => ({
      "--maxRows": m && c && m < c ? m : c,
      "--cellWidth": `${p}px`,
      "--pinCount": S
    }),
    [p, c, S, m]
  ), M = W(
    () => ({
      "--table-horizontal-offset": `translateX(${r}px)`
    }),
    [r]
  );
  return /* @__PURE__ */ k("div", { className: E, style: b, ...T, children: [
    /* @__PURE__ */ k("div", { className: l.captionWrapper, children: [
      /* @__PURE__ */ _("h2", { className: l.caption, children: C }),
      h && /* @__PURE__ */ k("div", { className: l.buttonWrapper, "data-testid": "scroll-controls", children: [
        /* @__PURE__ */ _(
          V,
          {
            "aria-label": "scroll table left",
            className: l.button,
            disabled: !e.left,
            onClick: () => y("left"),
            variant: "ghost",
            children: /* @__PURE__ */ _(v, { size: "xsm" })
          }
        ),
        /* @__PURE__ */ _(
          V,
          {
            "aria-label": "scroll table right",
            className: l.button,
            disabled: !e.right,
            onClick: () => y("right"),
            variant: "ghost",
            children: /* @__PURE__ */ _(v, { size: "xsm" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ _(
      "div",
      {
        className: N,
        onScroll: () => B(!!c),
        ref: i,
        style: M,
        children: u
      }
    )
  ] });
};
export {
  lt as T
};
